import {get} from "lodash"
import {
  defaultDeliveriesCalendarFieldOrder,
  defaultDeliveriesCalendarSelectedFields,
} from "helpers/deliveries/deliveries"
import {sortByKey} from "helpers/sorting"

export const getReadyForDelivery = state => state.deliveriesContext.readyForDelivery
export const getDeliveryNotes = state => state.deliveriesContext.deliveryNotes
export const getDeliveries = state => state.deliveriesContext.deliveries

export const getDeliveryDepartments = state =>
    get(state, 'deliveriesContext.deliveries.deliveryDepartments', [])

export const getDeliveryWorkCentres = state =>
    get(state, 'deliveriesContext.deliveries.deliveryWorkCentres', [])
        .sort((a, b) => sortByKey(a, b, 'sortOrder'))

export const isDeliveryWorkCentresLoaded = state =>
    get(state, 'deliveriesContext.deliveries.deliveryWorkCentresLoaded', false)

export const getDeliveryCalendarData = state =>
    get(state, 'deliveriesContext.deliveries.calendarData', [])

export const getDeliveriesCalendarSelectedDate = state =>
    get(state, 'deliveriesContext.deliveries.calendarSelectedDate', new Date())

export const getDeliveriesCalendarViewRange = state =>
    get(state, 'deliveriesContext.deliveries.calendarViewRange', 'month:0')

export const getDeliveriesCalendarFieldOrder = state =>
    get(state, 'deliveriesContext.deliveries.calendarFieldOrder')
    || defaultDeliveriesCalendarFieldOrder

export const getDeliveriesCalendarSelectedFields = state =>
    get(state, 'deliveriesContext.deliveries.calendarSelectedFields')
    || defaultDeliveriesCalendarSelectedFields

export const getSelectedDeliveryFiltersFromState = state =>
    get(state, 'deliveriesContext.deliveries.filters', [])

export const getSelectedDeliveryDepartmentId = state =>
    get(state, 'deliveriesContext.deliveries.selectedDepartment', null)

export const isLoadingDeliveryItems = state =>
    get(state, 'deliveriesContext.deliveries.isLoadingItems', false)

export const getDeliveryCounts = state =>
    get(state, 'deliveriesContext.deliveries.deliveryCounts', {})

export const getDeliveryDialogCurrentTab = state =>
    get(state, 'deliveriesContext.deliveries.deliveryDialogCurrentTab', 'Items')

export const isShowingDeliveryDialogOperationsValidityWarning = state =>
    get(state, 'deliveriesContext.deliveries.isShowingOperationsValidityWarning', true)

export const isSavingDelivery = state =>
    get(state, 'deliveriesContext.deliveries.isSavingDelivery', false)

export const getDeliveryDocuments = state =>
    get(state, 'deliveriesContext.deliveries.documents.data.data', [])

export const getDeliveriesQuoteSelector = state =>
    get(state, 'deliveriesContext.quoteSelector', null)

export const getDeliveriesQuoteSelectorOrders = state =>
    get(state, 'deliveriesContext.quoteSelector.quotes.data.data', null)

export const getDeliveriesQuoteSelectorSelectedOrderId = state =>
    get(state, 'deliveriesContext.quoteSelector.selectedOrderId', null)

export const getDeliveriesQuoteSelectorSelectedOrder = state => {
  const selectedOrderId = getDeliveriesQuoteSelectorSelectedOrderId(state)
  const orders = getDeliveriesQuoteSelectorOrders(state)
  return orders.find(order => order.id === selectedOrderId)
}

export const isObserving = state => state.deliveriesContext.deliveries.observing

export const getIncludeFullyDelivered = state => {
  return get(state, 'deliveriesContext.quoteSelector.includeFullyDelivered', false)
}
